export default {
    es: {
        title: "Simula tu ahorro!",
        subtitle: "Calcular lo que te vas a ahorrar contratando tu factura de la luz con Iner, ¡es muy fácil!",
        subtitle2: "Ten a mano tu factura de la luz para que podamos hacer mejor el cálculo de tu ahorro:",
        form: {
            power: "Potencia Contratada:",
            powerPlaceholder: "kW",
            consumed: "Consumido:",
            consumedPlaceholder: "kWh",
            consumedP1: "P1",
            consumedP2: "P2",
            consumedP3: "P3",
            billingPeriod: "Periodo de facturación:",
            billingPeriodFrom: "Desde",
            billingPeriodTo: "Hasta",
            paid: "Pagado en la factura:",
            paidPlaceholder: "Indica la cantidad",
            IVA: "Tipo de IVA:",
            IVA1: "10%",
            IVA2: "21%",
            btn: "Calcular",
        },
        resultView: {
            title: "¡Enhorabuena!",
            subtitle: "¡Ya tenemos tu tarifa perfecta y te vas a ahorrar un montón!",
            subtitle2: "Hemos calculado que con nosotros ahorrarías {amount}€ cada año.",
            subtitle3: "Te hemos enviado un email con tu cálculo de ahorro y toda la información.",
            ahorro: "Tu ahorro es de:",
            ahorroValue: "50,45€",
            year: "Al año con tu tarifa",
            tranquility: "TRANQUILIDAD",
            resultTarifas: {
                title: "Tus mejores opciones",
                year: "Al año",
                saving: "DE AHORRO",
            },
            bannerBenefits: {
                title: "Sin permanencia",
                subtitle: "Cambia cuando quieras, sin compromisos ni ataduras.",
                title2: "Alta online",
                subtitle2: "Contrata tu tarifa de luz de forma rápida y sencilla desde nuestra web.",
                title3: "Sin papeleos",
                subtitle3: "Nos encargamos de todo para que no tengas que preocuparte por nada.",
            },
            withoutSavings: {
                title: "Lo sentimos",
                subtitle: "Ya cuentas con unas condiciones muy competitivas.",
                subtitle2: "Tras analizar los datos de tu factura, no hemos identificado una oportunidad de ahorro significativa en este momento.<br>Esto significa que actualmente dispones de un precio energético muy ajustado. En Iner Energía creemos que la transparencia es fundamental, por eso solo te proponemos un cambio cuando existe un beneficio real para ti.",
                subtitle3: "Si tu contrato finaliza próximamente o cambian las condiciones de tu suministro, estaremos encantados de volver a revisarlo."
            },
        }
    }
}


// WEBPACK FOOTER //
// ./src/translations/new-simulador.js